<template>
   <div id="app">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
    
    <div class="app-wrapper">
      <div v-if="!$route.meta.limpio"> 
        <navigation></navigation>
      </div>
      
      <div v-if="processing">
        <BlockUI :message="blockMessage"></BlockUI>
      </div>

      <div v-if="warning">
        <BlockUI :message="warning"></BlockUI>
      </div>
    
      <div v-if="error">
        <BlockUI :message="error"></BlockUI>
      </div>

      <b-modal  no-close-on-backdrop no-close-on-esc hide-header hide-footer ok-only 
      v-model="updateExists"  id="modalupgrading" >
        <div class="text-center">
          <h5>Encontramos una nueva versión de la aplicación, es necesario actualizar.</h5>
          <b-button variant="success" @click="refreshApp">
            Actualizar ahora
          </b-button>
        </div>
      </b-modal>

      <div class="content-wrapper">
        <router-view></router-view>
      </div>
    </div>
    
    <footer
      v-if="!$route.meta.limpio"
      class="modern-footer"
      :class="{ 'mt-4': $route.name !== 'login' }"
    >
      <div class="footer-content">
        <div class="footer-main">
          <div class="footer-brand">
            <h5 class="brand-title">American School Way</h5>
            <p class="brand-subtitle">Programador de clases (Administrador)</p>
          </div>
          
          <div class="footer-info">
            <div class="info-item">
              <i class="fa fa-calendar"></i>
              <span>© 2018 - {{ new Date().getFullYear() }}</span>
            </div>
            <div class="info-item">
              <i class="fa fa-code"></i>
              <span>Versión {{ packageVersion }}</span>
            </div>
          </div>

          <div class="footer-flag">
            <div class="colombia-flag">
              <div class="flag-yellow"></div>
              <div class="flag-blue"></div>
              <div class="flag-red"></div>
            </div>
            <span class="flag-text">Hecho en Colombia</span>
          </div>
        </div>
        
        <div class="footer-bottom">
          <p class="footer-credit">Desarrollado con <i class="fa fa-heart heart-icon"></i> por el equipo de ASW</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import {mapState,mapActions} from 'vuex';
  import Navigation from '@/components/Navigation.vue';  
  import utils from '@/modules/utils';

  export default {
    components: {
        Navigation,
    },
    
    name: 'app',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App',
        blockMessage: 'Procesando...',
        upgrading: false,
        registration: null,
        updateExists: false,
      }
    },
    mounted(){
      
    },

    created(){
      this.getPermisos();
      //Necesario para las actualizaciones de la aplicacion
      //Ejecuta el evento updateAvailable cuando se encuentre actualizaciones
      document.addEventListener('swUpdated', this.updateAvailable, { once: true })
    },

    methods: {
      ...mapActions({
        setWarning: 'setWarning',
        fetchEnable:'fetchEnable',
        getPermisos: 'auth/getPermisos'
      }),
      
      reload(){
        window.location.reload(true);
      },
      updateAvailable(event) {
        this.registration = event.detail
        this.updateExists = true
      },
      refreshApp() {
        this.updateExists = false

        // Make sure we only send a 'skip waiting' message if the SW is waiting
        if (!this.registration || !this.registration.waiting) return
        
        //Permite la actualizacion del service worker
        this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })

        //Recarga la aplicacion
        window.location.reload(true);
      }
    },
    computed: {
      ...mapState({
        processing: state => state.processing,
        error: state => state.error,
        warning: state => state.warning,
        reportedVersion: state => state.version,
        packageVersion: state => state.packageVersion,
        baseUrl: state => state.baseUrl,
        nodeEnv: state => state.nodeEnv,
        appInstance: state => state.appInstance
      }),
      
      
    }
  }
</script>


<style>
#app {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app-wrapper {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  flex: 1 0 auto;
}

.bg-red{
    background-color:#BC2336;
}
.bg-blue{
    background-color:#0D4E8C !important;
}
hr {
  border: 1px solid #E33A2D !important;
  width: 100%;
}  
.bd-footer{background-color: #f7f7f7;font-size: 85%;}
.bd-footer p{
  margin:0px;
}

/* Modern Footer Styles */
.modern-footer {
  background: linear-gradient(135deg, #0D4E8C 0%, #084079 50%, #052e5c 100%);
  color: #ffffff;
  padding: 3rem 0 1.5rem;
  margin-top: 0;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
}

.modern-footer .footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.modern-footer .footer-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.modern-footer .footer-brand {
  flex: 1;
  min-width: 250px;
}

.modern-footer .brand-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  color: #ffffff;
  letter-spacing: 0.5px;
}

.modern-footer .brand-subtitle {
  margin: 0;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 300;
}

.modern-footer .footer-info {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex: 1;
  min-width: 200px;
}

.modern-footer .info-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.95);
}

.modern-footer .info-item i {
  font-size: 1.1rem;
  width: 20px;
  text-align: center;
}

.modern-footer .footer-flag {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
  min-width: 150px;
}

.modern-footer .colombia-flag {
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  width: 32px;
  transition: transform 0.3s ease;
}

.modern-footer .colombia-flag:hover {
  transform: scale(1.1);
}

.modern-footer .flag-yellow {
  background-color: #FCD116;
  height: 10px;
}

.modern-footer .flag-blue {
  background-color: #003893;
  height: 5px;
}

.modern-footer .flag-red {
  background-color: #CE1126;
  height: 5px;
}

.modern-footer .flag-text {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 300;
}

.modern-footer .footer-bottom {
  padding-top: 1.5rem;
  text-align: center;
}

.modern-footer .footer-credit {
  margin: 0;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 300;
}

.modern-footer .heart-icon {
  color: #ff6b6b;
  animation: heartbeat 1.5s ease-in-out infinite;
  display: inline-block;
}

@keyframes heartbeat {
  0%, 100% {
    transform: scale(1);
  }
  10%, 30% {
    transform: scale(1.1);
  }
  20%, 40% {
    transform: scale(1);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .modern-footer .footer-main {
    flex-direction: column;
    text-align: center;
    gap: 2rem;
  }
  
  .modern-footer .footer-brand,
  .modern-footer .footer-info,
  .modern-footer .footer-flag {
    min-width: 100%;
  }
  
  .modern-footer .footer-info {
    align-items: center;
  }
  
  .modern-footer {
    padding: 2rem 0;
  }
}
select, input {
  padding:1px 4px;
}
select, input:not( :has(> .input-group)){
  border-radius: 15px !important;
}
.input-group:has(.input-group-prepend) input{
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.input-group .input-group-prepend .input-group-text{
  border-top-left-radius: 15px !important;
  border-bottom-left-radius: 15px !important;
}
.input-group:has(.input-group-append) input{
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}
.input-group .input-group-append .input-group-text{
  border-top-right-radius: 15px !important;
  border-bottom-right-radius: 15px !important;
}
</style>
